/* eslint-disable */
import { Button } from "@chakra-ui/button";
import { FormControl, FormErrorMessage } from "@chakra-ui/form-control";
import { Input, InputGroup,
  InputLeftAddon
   } from "@chakra-ui/input";
import { Box } from "@chakra-ui/layout";
import { useToast } from "@chakra-ui/react";
import {
    Select
} from "chakra-react-select";
import { useCallback, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import * as yup from "yup";
import { getCourses } from "../../redux/api_calls/apiCalls";


export default function Register({ profile, dispatchProfileForm,profileImage,addedSubjects }) {
   const useYupValidationResolver = (validationSchema) =>
    useCallback(
      async (data) => {
        try {
          const values = await validationSchema.validate(data, {
            abortEarly: false,
          });

          return {
            values,
            errors: {},
          };
        } catch (errors) {
          console.log(errors);
          console.log(errors.inner);
          return {
            values: {},
            errors: errors.inner.reduce(
              (allErrors, currentError) => ({
                ...allErrors,
                [currentError.path]: {
                  type: currentError.type ?? "validation",
                  message: currentError.message,
                },
              }),
              {}
            ),
          };
        }
      },
      [validationSchema]
    );

  const validationSchema = yup.object({
    first_name: yup.string().required("First Name is required"),
    last_name: yup.string().required("Last Name is required"),
    email: yup.string().email("Not a valid email").required("Year is required"),
    mobile_no: yup
      .number()
      .typeError("Not a valid phone number")
      .required("Mobile Number is required")
      .test("len", "Not a valid phone number", (val) => {
        if (val) {
          return val.toString().length <= 15;
        }
        return false;
      })
  });

  const resolver = useYupValidationResolver(validationSchema);

  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({ resolver });

  const history = useHistory();
  const toast = useToast();

  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    const loadSubjects = async () => {
      let subjects = await getCourses();
      setSubjects(subjects);
    };
    loadSubjects();
  }, []);

  
  useEffect(() => {
    const setFieldData = () => {
    console.log("load");
      for (let key of Object.keys(profile)) {
        console.log("for");

        if (key && profile[key]) {
        console.log("if");
             if(key==="mobile_no")
            {
              var mobile_no = profile[key].split('-');
              setValue(key,mobile_no[1]);
            }
            else{
                setValue(key,profile[key]);
            }
        }
      }
    };

    setFieldData();
    // eslint-disable-next-line
  }, []);

  const onSubmit = async (val) => {
  const mobile_no = "+60"+"-"+val.mobile_no;

    let formData = new FormData();
    formData.append('first_name', val.first_name);
    formData.append('last_name', val.last_name);
    formData.append('address', val.address);
    if(profileImage!==undefined && typeof profileImage !== 'string'&& profileImage !== null)
    {
      formData.append('avatar', profileImage); 
    }
    
    formData.append('email', val.email);
    formData.append('joined_in', val.joined_in);
    formData.append('mobile_no', mobile_no);
    formData.append('tutor_reg_id', val.tutor_reg_id);
    if(val.subject_id!==undefined)
    {
      formData.append('subject_id[]', val.subject_id);
    }
 
    console.log(formData);

    dispatchProfileForm(formData);

  };

  return (
    <Box
      d="flex"
      justifyContent="center"
      alignItems="center"
      w={["95%", "90%", "70%", "60%", "85%"]}
    >
      <form
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          padding: "0px 1rem",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: "1rem",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Box
          d="flex"
          width="100%"
          flexDir={["column", "column", "row", "row", "row"]}
          style={{ gap: "1rem" }}
        >
          <FormControl
            isInvalid={errors.first_name && errors.first_name.message}
          >
            <Input
              type="text"
              fontSize="16px"
              fontWeight="600"
              style={{ fontFamily: "Mulish, sans-serif" }}
              borderRadius="10px"
              h="40px"
              border="1px solid rgba(0, 0, 0, 0.1)"
              bg="#fcfcfc"
              id="firstName"
              placeholder="First Name"
              {...register("first_name")}
            />
            <FormErrorMessage>
              {errors.first_name && errors.first_name.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.last_name && errors.last_name.message}>
            <Input
              type="text"
              fontSize="16px"
              fontWeight="600"
              style={{ fontFamily: "Mulish, sans-serif" }}
              borderRadius="10px"
              h="40px"
              border="1px solid rgba(0, 0, 0, 0.1)"
              bg="#fcfcfc"
              id="lastName"
              placeholder="Last Name"
              {...register("last_name")}
            />
            <FormErrorMessage>
              {errors.last_name && errors.last_name.message}
            </FormErrorMessage>
          </FormControl>
        </Box>

        <FormControl isInvalid={errors.email && errors.email.message}>
          <Input
            type="email"
            fontSize="16px"
            fontWeight="600"
            style={{ fontFamily: "Mulish, sans-serif" }}
            borderRadius="10px"
            h="40px"
            border="1px solid rgba(0, 0, 0, 0.1)"
            bg="#fcfcfc"
            id="email"
            placeholder="Email Address"
            {...register("email")}
            disabled
          />
          <FormErrorMessage>
            {errors.email && errors.email.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.mobile_no && errors.mobile_no.message}>
           <InputGroup>
        <InputLeftAddon children='+60' />
          <Input
            type="text"
            fontSize="16px"
            fontWeight="600"
            style={{ fontFamily: "Mulish, sans-serif" }}
            borderRadius="10px"
            h="40px"
            border="1px solid rgba(0, 0, 0, 0.1)"
            bg="#fcfcfc"
            id="mobileNumber"
            placeholder="Mobile Number"
            {...register("mobile_no")}

          />
          <FormErrorMessage>
            {errors.mobile_no && errors.mobile_no.message}
          </FormErrorMessage>
          </InputGroup>
        </FormControl>

        <FormControl isInvalid={errors.joined_in && errors.joined_in.message}>
          <Input
            type="date"
            fontSize="16px"
            fontWeight="600"
            style={{ fontFamily: "Mulish, sans-serif" }}
            borderRadius="10px"
            h="40px"
            border="1px solid rgba(0, 0, 0, 0.1)"
            bg="#fcfcfc"
            id="joinedIn"
            placeholder="Joined In"
            {...register("joined_in")}
            disabled
          />
          <FormErrorMessage>
            {errors.joined_in && errors.joined_in.message}
          </FormErrorMessage>
        </FormControl>

        

        <FormControl isInvalid={errors.address && errors.address.message}>
          <Input
            type="text"
            fontSize="16px"
            fontWeight="600"
            style={{ fontFamily: "Mulish, sans-serif" }}
            borderRadius="10px"
            h="40px"
            border="1px solid rgba(0, 0, 0, 0.1)"
            bg="#fcfcfc"
            id="mobileNumber"
            placeholder="Address"
            {...register("address")}
          />
          <FormErrorMessage>
            {errors.address && errors.address.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.subject_id && errors.subject_id.message}>
          <Controller
            control={control}
            name="subject_id"
            render={({ field: { onChange } }) => (
              <Select
                isMulti
                border="1px solid rgba(0, 0, 0, 0.1)"
                height="40px"
                fontSize="18px"
                placeholder="Subject"
                onChange={(val) => {
                  let newValues = val.map((e) => e.value);
                  onChange(newValues);
                  return val;
                }}
                // name="subject_id"
                options={subjects.map((e) => ({
                  label: e.name,
                  value: e.id.toString(),
                }))}
              />
            )}
          />
          <FormErrorMessage fontSize="sm">
            {errors.subject_id && errors.subject_id.message}
          </FormErrorMessage>
        </FormControl>
        <Box
          d="flex"
          width="100%"
           style={{ gap: "1rem" }}
        >{addedSubjects}</Box>
        <Box
          width={["100%", "100%", "90%", "85%"]}
          d="flex"
          flexDir={["column", "column", "row", "row"]}
          justifyContent={["center", "center", "flex-start", "flex-start"]}
          mt="2rem"
        >
          <Button
            bgColor="#A0A4D9"
            color="white"
            borderRadius="lg"
            p={["6px 15px", "8px 20px", "12px 30px"]}
            _hover={{ bg: "#9093c2" }}
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="800"
            fontSize={["13px", "14px", "16px"]}
            mr={["0", "0", "20px", "20px"]}
            mb={["20px", "20px", "0", "0"]}
            type="submit"
            // onClick={saveChangesHandler}
          >
            Save Changes
          </Button>
          <Button
            bgColor="white"
            color="#999999"
            borderRadius="lg"
            border="1px solid rgba(0, 0, 0, 0.2)"
            p={["6px 15px", "8px 20px", "12px 30px"]}
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="800"
            fontSize={["13px", "14px", "16px"]}
            // onClick={cancelHandler}
          >
            Cancel
          </Button>
        </Box>
      </form>
    </Box>
  );
}
